export default "__VITE_ASSET__ozHvh_I2__"